import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'

function addListeners_etron_2025(frontCheckboxesMap, modalsCheckboxesMap) {
	
	frontCheckboxesMap['YS1'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YS1', this.checked);
		checkLocks_etron_2025(frontCheckboxesMap)
		getPackageImages_etron_2025('YS1', frontCheckboxesMap)
	})

	frontCheckboxesMap['YVE'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVE',this.checked)
		checkLocks_etron_2025(frontCheckboxesMap)
		getPackageImages_etron_2025('YVE', frontCheckboxesMap)
	})

	frontCheckboxesMap['YVJ'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVJ', this.checked) 
		if (this.checked) {
			activateConnectedPackages(["YVU_etron", "YSR"], frontCheckboxesMap);
		} else {
			deactivateConnectedPackages([ "YVU_etron", "YSR"], frontCheckboxesMap);
		}
		checkLocks_etron_2025(frontCheckboxesMap)
		getPackageImages_etron_2025('YVJ', frontCheckboxesMap)
	})

	frontCheckboxesMap['YSJ'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSJ', this.checked)
		checkLocks_etron_2025(frontCheckboxesMap)
		getPackageImages_etron_2025('YSJ', frontCheckboxesMap)
	})

	frontCheckboxesMap['YFA_etronGT'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YFA_etronGT', this.checked);
		if (this.checked) {  
			activateConnectedPackages(["YS1", "YSJ", "YVU_etron", "YSR"], frontCheckboxesMap);
		} else {
			deactivateConnectedPackages(["YS1", "YSJ", "YVU_etron", "YSR"], frontCheckboxesMap);
		}
		checkLocks_etron_2025(frontCheckboxesMap)
		getPackageImages_etron_2025('YFA_etronGT', frontCheckboxesMap)
	})

	frontCheckboxesMap['YFB_etronGT'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YFB_etronGT', this.checked);
		if (this.checked) {  
			activateConnectedPackages(["YVJ", "YVU_etron", "YSR"], frontCheckboxesMap);
		} else {
			deactivateConnectedPackages(["YVJ", "YVU_etron", "YSR"], frontCheckboxesMap);
		}
		checkLocks_etron_2025(frontCheckboxesMap)
		getPackageImages_etron_2025('YFB_etronGT', frontCheckboxesMap)
	})

	frontCheckboxesMap['YVU_etron'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVU_etron', this.checked);
		checkLocks_etron_2025(frontCheckboxesMap)
		getPackageImages_etron_2025('YVU_etron', frontCheckboxesMap)
	})
		
	frontCheckboxesMap['YTQ'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTQ', this.checked);
		checkLocks_etron_2025(frontCheckboxesMap)
		getPackageImages_etron_2025('YTQ', frontCheckboxesMap)
	})

	frontCheckboxesMap['YSR'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSR', this.checked);
		checkLocks_etron_2025(frontCheckboxesMap)
		getPackageImages_etron_2025('YSR', frontCheckboxesMap)
	})


}

function activateConnectedPackages(packageIds, frontCheckboxesMap) {
    packageIds.forEach(function (id) {
        if (frontCheckboxesMap[id] && !frontCheckboxesMap[id].checked) {
            //frontCheckboxesMap[id].click();
            // Optional: falls .click() nicht reicht, kann man auch direkt setzen:
            frontCheckboxesMap[id].checked = true;
            saveStateWithAjax(id, true);
            frontCheckboxesMap[id].parentElement.classList.add('is-checked');
			getPackageImages_etron_2025(id, frontCheckboxesMap);
        }
    });
}

function deactivateConnectedPackages(packageIds, frontCheckboxesMap) {
    packageIds.forEach(function (id) {
        if (frontCheckboxesMap[id]) {
            frontCheckboxesMap[id].disabled = false;
            frontCheckboxesMap[id].parentElement.classList.remove('is-checked');
            frontCheckboxesMap[id].checked = false;
            saveStateWithAjax(id, false);
            getPackageImages_etron_2025(id, frontCheckboxesMap);
        }
    });
}

/**Controls frontcheckboxes disable */
function checkLocks_etron_2025(frontCheckboxesMap) {

	//DEFINE UNLOCK CONDITIONS
	const unlockConditionForYS1 = !frontCheckboxesMap['YVJ'].checked && !frontCheckboxesMap['YVE'].checked && !frontCheckboxesMap['YFA_etronGT'].checked
	const unlockConditionForYVE = !frontCheckboxesMap['YFA_etronGT'].checked && !frontCheckboxesMap['YS1'].checked && !frontCheckboxesMap['YVU_etron'].checked && !frontCheckboxesMap['YVJ'].checked && !frontCheckboxesMap['YTQ'].checked && !frontCheckboxesMap['YSR'].checked	
	const unlockConditionForYVJ = !frontCheckboxesMap['YS1'].checked && !frontCheckboxesMap['YVU_etron'].checked && !frontCheckboxesMap['YFA_etronGT'].checked && !frontCheckboxesMap['YFB_etronGT'].checked && !frontCheckboxesMap['YSR'].checked && !frontCheckboxesMap['YVE'].checked
	const unlockConditionForYSJ = !frontCheckboxesMap['YFA_etronGT'].checked
 	const unlockConditionForYFA = !frontCheckboxesMap['YVJ'].checked && !frontCheckboxesMap['YVE'].checked && !frontCheckboxesMap['YFB_etronGT'].checked
    const unlockConditionForYFB = !frontCheckboxesMap['YFA_etronGT'].checked && !frontCheckboxesMap['YS1'].checked && !frontCheckboxesMap['YVE'].checked && !frontCheckboxesMap['YVU_etron'].checked && !frontCheckboxesMap['YSR'].checked
	const unlockConditionForYVU = !frontCheckboxesMap['YVJ'].checked && !frontCheckboxesMap['YVE'].checked && !frontCheckboxesMap['YFB_etronGT'].checked
	const unlockConditionForYTQ = !frontCheckboxesMap['YVE'].checked
	const unlockConditionForYSR = !frontCheckboxesMap['YVJ'].checked && !frontCheckboxesMap['YVE'].checked && !frontCheckboxesMap['YFB_etronGT'].checked
	
	//UPDATE VARS 
	frontCheckboxesMap['YS1'].disabled = !unlockConditionForYS1
	frontCheckboxesMap['YVE'].disabled = !unlockConditionForYVE
	frontCheckboxesMap['YVJ'].disabled = !unlockConditionForYVJ
	frontCheckboxesMap['YSJ'].disabled = !unlockConditionForYSJ
	frontCheckboxesMap['YFA_etronGT'].disabled = !unlockConditionForYFA
	frontCheckboxesMap['YFB_etronGT'].disabled = !unlockConditionForYFB
	frontCheckboxesMap['YVU_etron'].disabled = !unlockConditionForYVU
	frontCheckboxesMap['YTQ'].disabled = !unlockConditionForYTQ
	frontCheckboxesMap['YSR'].disabled = !unlockConditionForYSR

	// SPECIAL CASE
	//If YFB_etronGT is checked, then delete disabled
	if (frontCheckboxesMap['YFB_etronGT'].checked) {
		frontCheckboxesMap['YFB_etronGT'].disabled = false
	}
	// SPECIAL CASE
	//If YVJ is checked and YFB is unchecked, then delete disabled
	if (frontCheckboxesMap['YVJ'].checked && !frontCheckboxesMap['YFB_etronGT'].checked) {
		frontCheckboxesMap['YVJ'].disabled = false
		frontCheckboxesMap['YFB_etronGT'].disabled = false
	}
	// SPECIAL CASE
	//If YFA_etronGT is checked, then delete disabled
	if (frontCheckboxesMap['YFA_etronGT'].checked) {
		frontCheckboxesMap['YFA_etronGT'].disabled = false
		frontCheckboxesMap['YVU_etron'].disabled = true
		frontCheckboxesMap['YSR'].disabled = true
	}
		
}

/**Gets images for all packages depending on selected packages */
function getImages_etron_2025(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		getPackageImages_etron_2025(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_etron_2025(packageCode, checkboxesMap) {
	
	// Special case for YSR
	if (packageCode == 'YSR' && (checkboxesMap['YVJ'].checked || checkboxesMap['YFB_etronGT'].checked)) {
		packageCode = 'YVJ'
	}
	// Special case for YVU_etron
	if (packageCode == 'YVU_etron' && (checkboxesMap['YVJ'].checked || checkboxesMap['YFB_etronGT'].checked)) {
		packageCode = 'YVJ'
	}
	// Special case for YFB_etronGT
	if (packageCode == 'YFB_etronGT') {
		packageCode = 'YVJ'
	}

	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')
	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)

	} else {
		pressedPackageImg.hidden = !isChecked
	}
	
}


export { addListeners_etron_2025, saveStateWithAjax, checkLocks_etron_2025, getImages_etron_2025, getPackageImages_etron_2025}